export enum CalendarFollowUpDisplay {
  Hours = "Hours",
  Days = "Days",
}
